import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { M3ButtonComponent } from '@shared/button/m3-button.component';

@Component({
  selector: 'app-sso-sign-in-button',
  imports: [M3ButtonComponent, MatIconModule],
  template: `
    <app-m3-button
      variant="tonal"
      (click)="buttonClick.emit()"
      [disabled]="disabled()"
    >
      <mat-icon class="sso-icon">key</mat-icon>
      {{ buttonText() }}
    </app-m3-button>
  `,
  styles: [
    `
      .sso-icon {
        margin-right: 8px;
        font-size: 20px;
        width: 20px;
        height: 20px;
      }
    `,
  ],
})
export class SsoSignInButtonComponent {
  buttonText = input.required<string>();
  disabled = input(false);
  buttonClick = output<void>();
}
